import { Link } from 'app/components/ExternalLink';

export interface AppStoreButtonProps {
  store: 'IOS' | 'Android';
  height?: string | number;
  width?: string | number;
}

export function AppStoreButton(props: AppStoreButtonProps) {
  const { store, height, width } = props;
  const IOSLink = 'https://itunes.apple.com/ca/app/bookitlab/id707458905?mt=8';
  const AndroidLink =
    'https://play.google.com/store/apps/details?id=com.prog4biz.bookitlab';
  return (
    <Link href={store === 'IOS' ? IOSLink : AndroidLink}>
      <img
        style={{ height: height || '40px', maxWidth: width || '120px' }}
        alt={
          store === 'IOS' ? 'Get it on Apple Store' : 'Get it on Google Play'
        }
        src={`${process.env.PUBLIC_URL}${
          store === 'IOS'
            ? '/images/ios-app-store.png'
            : '/images/android-app-store.png'
        }`}
      />
    </Link>
  );
}
